import { cn } from '../../../utils';

// ============================================================================
// AnimatedDots - Shared loading/typing indicator dots
// ============================================================================

export interface AnimatedDotsProps {
  /** Size of the dots */
  size?: 'sm' | 'md';
  /** Color variant */
  variant?: 'default' | 'brand' | 'agent' | 'user';
  /** Additional class names */
  className?: string;
}

const sizeClasses = {
  sm: 'h-1 w-1',
  md: 'h-1.5 w-1.5',
};

const variantClasses = {
  default: 'bg-slate-400 dark:bg-slate-500',
  brand: 'bg-purple-500 dark:bg-purple-400',
  agent: 'bg-purple-500 dark:bg-purple-400',
  user: 'bg-sky-500 dark:bg-sky-400',
};

export const AnimatedDots = ({
  size = 'md',
  variant = 'default',
  className,
}: AnimatedDotsProps) => (
  <span className={cn('inline-flex items-center gap-1', className)}>
    {[0, 1, 2].map((i) => (
      <span
        key={i}
        className={cn(
          sizeClasses[size],
          'rounded-full animate-fade-pulse',
          variantClasses[variant]
        )}
        style={{ animationDelay: `${i * 150}ms` }}
      />
    ))}
  </span>
);
AnimatedDots.displayName = 'AnimatedDots';
